import React from 'react'
import styled from 'styled-components'
import Footer from './Footer'
import Logo from './Logo'
import closeImg from '../../assets/close.png'
import diamond from '../../assets/diamond.png'
import home from '../../assets/homeImg.png'
import settings from '../../assets/settingsImg.png'
import disconnect from '../../assets/disconnect.png'
import messages from '../../assets/messages.png'
import { logout } from '../../utils/services/fetchUser'
import { useNavigate } from 'react-router-dom'
import colors from '../../styles/colors'

// Styles de la sidebar
const SidebarContainer = styled.div`
    position: fixed;
    top: 0;
    left: ${({ isSidebarOpen }) => (isSidebarOpen ? '0' : '-250px')};
    width: 250px;
    height: 100vh;
    background-color: white;
    transition: left 0.5s ease-out;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    box-shadow: ${({ isSidebarOpen }) =>
        isSidebarOpen ? '5px 0 15px rgba(0, 0, 0, 0.3)' : 'none'};
    z-index: 1500;
`
const StyledTopContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`
const SidebarOpenClose = styled.div`
    position: absolute;
    right: -65px;
    top: 15px;
    background-color: white;
    color: grey;
    font-size: 40px;
    font-weight: 500;
    width: 50px;
    height: 50px;
    display: flex; /* Utilise Flexbox pour l'alignement */
    align-items: center; /* Centre verticalement le contenu */
    justify-content: center; /* Centre horizontalement le contenu */
    text-align: center; /* Centre le texte en cas de texte long */
    border-radius: 50%;
    box-shadow: 0 0 30px grey;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    &:hover {
        filter: brightness(0.8);
    }
`

const StyledUserPicture = styled.div`
    display: flex;
    position: relative;
    height: 150px;
    border-radius: 100px;
`
const StyledUserPictureImg = styled.img`
    position: absolute;
    top: 0;
    right: -75px;
    border-radius: 100px;
    height: 150px;
    width: 150px;
    object-fit: cover;
    box-shadow: 0 0 15px grey;
    transition: all 0.3s ease-in-out;
    &:hover {
        cursor: pointer;
        filter: brightness(0.8);
    }
`
const StyledUserPicturePremium = styled.img`
    position: absolute;
    top: 5px;
    right: -80px;
    width: 40px;
    object-fit: cover;
    aspect-ratio: 1/1;
    background-color: white;
    border-radius: 50px;
    padding: 8px;
    box-shadow: 0 0 15px grey;
`
const StyledPseudo = styled.div`
    font-weight: bold;
    margin: 20px;
    color: ${colors.forth};
`
const StyledOptions = styled.div`
    display: flex;
    flex-direction: column;
`
const SidebarItem = styled.div`
    display: flex;
    align-items: center;
    margin: 15px 0;
    color: ${colors.forth};
    font-size: 110%;
    transform: all 0.5s ease;
    cursor: pointer;
    &:hover {
        filter: brightness(1.5);
    }
    img {
        width: 25px;
    }
`

// Composant principal pour la sidebar
const Sidebar = ({ setIsSidebarOpen, isSidebarOpen, userInfo }) => {
    const navigate = useNavigate() // Initialiser le hook useNavigate

    const handleOnClickLogout = async () => {
        try {
            await logout()
            // Redirige l'utilisateur vers la page de connexion ou la page d'accueil
            window.location.replace('/')
        } catch (error) {
            console.error('Erreur lors de la déconnexion :', error)
            alert('La déconnexion a échoué, veuillez réessayer.')
        }
    }
    return (
        <>
            {userInfo && (
                <SidebarContainer isSidebarOpen={isSidebarOpen}>
                    <StyledTopContainer>
                        <SidebarOpenClose
                            onClick={() => setIsSidebarOpen((prev) => !prev)}
                        >
                            {isSidebarOpen ? '-' : '+'}
                        </SidebarOpenClose>
                        <Logo />
                        <StyledUserPicture>
                            <StyledUserPictureImg
                                src={userInfo.pictureUrl}
                                alt="User"
                                onClick={() =>
                                    navigate(`/PublicProfile/${userInfo._id}`)
                                }
                            />
                            {userInfo.premium && (
                                <StyledUserPicturePremium
                                    src={diamond}
                                    alt="premium"
                                />
                            )}
                        </StyledUserPicture>
                        <StyledPseudo>{userInfo.pseudo}</StyledPseudo>
                        <StyledOptions>
                            <SidebarItem onClick={() => navigate('/Dashboard')}>
                                <img src={home} alt="home" />
                                &nbsp; Accueil
                            </SidebarItem>
                            <SidebarItem onClick={() => navigate('/Chat')}>
                                <img src={messages} alt="messages" />
                                &nbsp; Messages
                            </SidebarItem>
                            <SidebarItem
                                onClick={() => navigate('/PrivateProfile')}
                            >
                                <img src={settings} alt="settings" />
                                &nbsp; Paramètres
                            </SidebarItem>
                            <SidebarItem onClick={handleOnClickLogout}>
                                <img src={disconnect} alt="logoff" />
                                &nbsp; Déconnexion
                            </SidebarItem>
                        </StyledOptions>
                    </StyledTopContainer>
                    <Footer />
                </SidebarContainer>
            )}
        </>
    )
}

export default Sidebar
